import { urlBaseMatch, urlBase } from "./config";
import axiosInstance from "../services/config/axiosinstance";

function delMatch({ id, jwt }) {
  var config = {
    method: "delete",
    url: `${urlBaseMatch}/rooms/${id}`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

function getMatch({ eventId, limit, offset, search, jwt, active = true }) {
  var config = {
    method: "get",
    url: `${urlBaseMatch}/report?limit=${limit}&offset=${offset}&eventId=${eventId}&search=${search}&active=${active}`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

async function createRoom(data, jwt) {
  const config = {
    method: "post",
    url: `${urlBaseMatch}/room`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };
  try {
    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
}

async function getParticipants({
  eventId,
  loginId,
  offset,
  limit,
  search = "",
  jwt,
}) {
  const config = {
    method: "get",
    url: `${urlBaseMatch}/login/event/${eventId}/login/${loginId}?offset=${offset}&limit=${limit}&search=${search}`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
}

async function sendInviteConfirmation(data) {
  const config = {
    method: "post",
    url: `${urlBaseMatch}/roommateroom/inviteconfirmation`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { ...data },
  };
  try {
    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
}

async function getRoommatesRoom(eventId, roommateId, jwt) {
  const config = {
    method: "get",
    url: `${urlBaseMatch}/roommateroom/event/${eventId}/roommate/${roommateId}`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
}

function getMatchNoRoom({ eventId, limit, offset, jwt }) {
  var config = {
    method: "get",
    url: `${urlBaseMatch}/report/roomatesavailable?limit=${limit}&offset=${offset}&eventId=${eventId}`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

function getStockRooms({ eventId, jwt = "" }) {
  // console.log(`${urlBaseMatch}/events/${eventId}/rooms`)
  var config = {
    method: "get",
    url: `${urlBaseMatch}/events/${eventId}/rooms`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

function upsertRoomCapacity(data, jwt) {
  var config = {
    method: "post",
    url: `${urlBaseMatch}/roomscapacity`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { payload: data },
  };
  return axiosInstance(config)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response.data;
    });
}

function createConfigMatch({ data, token, typeSendApi }) {
  var config = {
    method: typeSendApi,
    url: `${urlBase}/matchconfig`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };
  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

function getConfigMatch({ token, eventId }) {
  var config = {
    method: "get",
    url: `${urlBase}/matchconfig/${eventId}/event?offset=1&limit=10`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

async function createMatchImport({
  event,
  host_one,
  host_two,
  host_three,
  host_four,
  jwt,
}) {
  var data = JSON.stringify({
    event: event,
    host_one,
    host_two,
    host_three,
    host_four,
  });

  var config = {
    method: "post",
    url: `${urlBase}/flights/import`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwt}`,
    },
    data,
  };

  return axios(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

async function deleteAllRooms(eventId) {
  const config = {
    method: "delete",
    url: `${urlBaseMatch}/rooms/${eventId}/event`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
}

export {
  getMatch,
  delMatch,
  getStockRooms,
  upsertRoomCapacity,
  createConfigMatch,
  getConfigMatch,
  getMatchNoRoom,
  createRoom,
  getRoommatesRoom,
  getParticipants,
  sendInviteConfirmation,
  createMatchImport,
  deleteAllRooms,
};
